/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 3/31/2022.
 */

import React from 'react';
import {Icon, Modal} from "@scuf/common";
import {withRouter} from "react-router";
import {ROLES} from "../security/SecurityConst";
import hdaMechanicHelpImage from '../styling/images/HelpImageForHDAMechanic.png';
import hdaAdminHelpImage from '../styling/images/HelpImageForHDAAdmin.png';

class HelpWindow extends React.Component {

    render() {
        const imagesBasedOnRole = new Map();
        imagesBasedOnRole.set(ROLES.HDA_MECHANIC, hdaMechanicHelpImage);
        imagesBasedOnRole.set(ROLES.HDA_ADMIN, hdaAdminHelpImage);
        imagesBasedOnRole.set(ROLES.AIRTIME_GENERIC,hdaMechanicHelpImage);

        return (
            <div className="helpModal navbar-icon">
                <Modal
                    size="large"
                    trigger={<Icon root="building" name="badge-help" size={"large"}/>}>
                    <Modal.Content scrolling={false}>
                        <img className={"helpModal-image"} src={imagesBasedOnRole.get(this.props.role)}
                             alt={"Image could not be loaded"}/>
                    </Modal.Content>
                </Modal>
            </div>
        );
    }
}


export default withRouter((HelpWindow));